<template>
<div class="w-100 h-100 p-relative">
  <div class="container container-uedahiraku h-100">
    <div class="row h-100">
      <div class="col-md-5 d-none d-md-flex align-items-center">
        <div>
          <h3 class="futura">CONTACT</h3>
          <p>
            展示や作品のご依頼等、ご相談ください。<br>
            運営よりご連絡させていただきます。<br>
            <br>
            <small class="text-muted">
              ※開催中の展示に関するお問い合わせは
              展示会場の方に直接ご連絡ください。
            </small>

          </p>
        </div>
      </div>
      <div class="col-md-7 d-flex align-items-center">
        <div class="card w-100 border-black">
          <div v-if="!nowLoading && !showToast" class="card-body">
            <b-form-group
              id="input-group-1"
              label="名前"
              label-for="input-1"
            >
              <b-form-input
                id="input-1"
                v-model="form.name"
                type="text"
                required
                placeholder="山田 太郎"
                :state="validated? valid.name: null"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-2"
              label="電話"
              label-for="input-2"
            >
              <b-form-input
                id="input-2"
                v-model="form.phone"
                type="text"
                placeholder="080-1234-5678"
              ></b-form-input>
            </b-form-group>
            <b-form-group
              id="input-group-3"
              label="メール"
              label-for="input-3"
            >
              <b-form-input
                id="input-3"
                v-model="form.email"
                type="email"
                required
                placeholder="yourname@example.com"
                :state="validated? valid.email: null"
              ></b-form-input>
            </b-form-group>

            <b-form-group
              id="input-group-4"
              label="お問い合わせ内容"
              label-for="input-4"
            >
              <b-form-textarea
                id="input-4"
                v-model="form.message"
                placeholder="お問い合わせ内容をどうぞ"
                :state="validated? valid.message: null"
              ></b-form-textarea>
            </b-form-group>
            <b-button @click="validate" :variant="canSubmit? 'success': 'outline-white'">
              <font-awesome-icon icon="paper-plane" class="mr-2" />
              送信
            </b-button>
          </div><!-- /.card-body -->
          <div v-else-if="nowLoading" class="card-body py-5">
            <div class="py-5 my-5">
              <div class="text-center">
                <b-spinner label="Spinning"></b-spinner>
              </div>
            </div>
          </div>
          <div v-else class="card-body">
            <div class="text-right">
              <b-button class="p-0" variant="outline-dark" @click="showToast = false; nowLoading = false">
                <svg xmlns="http://www.w3.org/2000/svg" width="33" height="33" viewBox="0 0 33 33">
                  <line x1="0" y1="0" x2="33" y2="33" stroke="currentColor" />
                  <line x1="0" y1="33" x2="33" y2="0" stroke="currentColor" />
                </svg>
              </b-button>
            </div>
            メール送信しました<br>
            <dl>
              <dt>名前</dt>
              <dd>{{form.name}}</dd>
              <dt>でんわ</dt>
              <dd>{{form.phone}}</dd>
              <dt>メール</dt>
              <dd>{{form.email}}</dd>
              <dt>お問い合わせ内容</dt>
              <dd>{{form.message}}</dd>
            </dl>

          </div><!-- /.card-body -->
        </div>
      </div>
    </div>
  </div>
  <h2 class="right-title futura tracking-1">CONTACT</h2>
  <div class="right-item">
    <div class="tategaki font-weight-bold">
      各種お問い合わせはコチラから
    </div>
  </div>
  
</div>
</template>

<script>
export default {
  name: 'Contact',
  components: {
  },
  data() {
    return {
      form: {
        name: '',
        email: '',
        phone: '',
        message: ''
      },
      valid: {
        name: false,
        email: false,
        message: false
      },
      validated: false,
      showToast: false,
      nowLoading: false
    }
  },
  computed: {
    canSubmit() {
      if (this.form.name.length > 0 && this.form.message.length > 0 && this.checkEmailAddress()) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    validate() {
      if (this.canSubmit) {
        this.submit()
      } else {
        this.validated = true
        this.valid.name = this.form.name.length > 0
        this.valid.email = this.checkEmailAddress()
        this.valid.message = this.form.message.length > 0

        return false
      }
    },
    submit() {
      this.nowLoading = true
      this.getNonce()
    },
    async getNonce() {
      const payload = await this.axios.get(process.env.VUE_APP_API_BASE_URL + '/wp-json/uedahiraku/v1/nonce')
      .catch((e) => {
        console.log(e)
      });
      console.log(payload)
      if (payload.data) {

        this.sendMail(payload.data)
      }
    },
    async sendMail(nonce) {
      let formdata = new URLSearchParams();
      formdata.append('nonce', nonce);
      formdata.append('email', this.form.email);
      formdata.append('name', this.form.name);
      formdata.append('phone', this.form.phone);
      formdata.append('message', this.form.message);

      const payload = await this.axios.post(
        process.env.VUE_APP_API_BASE_URL + '/wp-json/uedahiraku/v1/sendmail',
        formdata
      )
      .catch((e) => {
        console.log(e)
      });
      console.log(payload)
      if (payload.data) {
        // 送信完了でView入れ替え
        this.showToast = true
        this.nowLoading = false
      }
    },
    checkEmailAddress(){
      if (this.form.email.match(/.+@.+\..+/) == null){
        return false;
      } else {
        return true;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* for Webkit */
.form-control::-webkit-input-placeholder{
    color: #9f9f9f;
    // font-size: 0.9em;
}
 
/* for Firefox */
.form-control::-moz-placeholder{
    color: #9f9f9f;
    // font-size: 0.9em;
}
 
/* for Firefox 18以前 */
.form-control:-moz-placeholder{
    color: #9f9f9f;
    // font-size: 0.9em;
}
 
/* for Windows IE */
.form-control:-ms-input-placeholder{
    color: #9f9f9f;
    // font-size: 0.9em;
}
</style>